import { Link } from "react-router-dom";
import { LI, UL } from "../../../../AbstractElements";
import { SOCIAL_MEDIA_ICON } from "../../../../Data/Chat";

const SocialMediaIcon = () => {
  return (
    <UL className="simple-list flex-row list-inline">
      {SOCIAL_MEDIA_ICON.map((data, index) => (
        <LI className="list-inline-item" key={index}>
          <Link to={data.link}>
            <i className={`fa ${data.icon}`} />
          </Link>
        </LI>
      ))}
    </UL>
  );
};

export default SocialMediaIcon;
